module.exports = __webpack_public_path__ + "static/promo-background-darker-23cd57a6e0207d524d1a4f247d42203b.jpg";